<template>
  <span
    class="cm-like"
    :data-company="company.id"
    :class="{
      'cm-like--liked': liked,
      'is-flashing': likeLoading,
    }"
    @click.prevent="toggleLike"
  >
    <i class="ss-icon">heart</i>
  </span>
</template>

<script>
export default {
  props: ["company"],

  data() {
    return {
      liked: this.company.liked,
      likeLoading: false
    };
  },

  methods: {
    toggleLike() {
      this.likeLoading = true;

      if (!this.liked) {
        window.makeItRainHearts();
      }

      this.$http.put(`/companies/${this.company.id}/like.json`).then(
        response => {
          this.liked = !this.liked;

          if (this.liked) {
            this.$emit("like");
          } else {
            this.$emit("unlike");
          }

          this.likeLoading = false;
        },
        error => {
          // TODO Display error messages
        }
      );
    }
  }
};
</script>

<style lang="scss" scoped>
.cm-like {
  cursor: pointer;
  height: 20px;
  width: 20px;
  border-radius: 50%;
  background: white;
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 2;

  &--liked {
    color: red;
  }

  &:hover {
    box-shadow: 0px 0px 5px 2.5px RGB(from var(--bg-2) r g b / 0.25);
  }

  i {
    @include icon;

    font-size: 10px;
    position: relative;
    top: 1px;
  }
}
</style>



// WEBPACK FOOTER //
// app/javascript/company/heart.vue?59c9049a